import { actions, api } from '../constants/app_constants.js';
import { request_helper } from "./request_helper.js";

export const appActions = {
    getAppSettings: () => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_APP_SETTINGS;

        try {
            let data = await request_helper.callWithDispatch(dispatch, "GET", url);
            let appSettings = {
                deviceTypes: data.deviceTypes,
                ioTypes: data.ioTypes,
                ioActionTypes: data.ioActionTypes,
                appModulesAccess: data.appModulesAccess,
                appFieldsAccess: data.appFieldsAccess,
            }
            dispatch({ type: actions.GET_APP_SETTINGS, appSettings });
        } catch (error) {
            dispatch({ type: actions.HANDLE_ERROR, error });
        } 
    },
    clearError: () => (dispatch, getState) => {
        dispatch({ type: actions.CLEAR_ERROR });
    }
};